exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.table.borderless th[data-v-43872f49],\n.table.borderless td[data-v-43872f49],\n.table.borderless[data-v-43872f49] {\n    border: 0;\n}\n", ""]);

// exports
